import React from 'react';
import { Title, Wrapper } from './styles';

const HomeDashboard = () => {
    return (
        <Wrapper>
            <Title> dassboard </Title>
        </Wrapper>
    );
};

export default HomeDashboard;
